const checkEmail = (input) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return input ? input.length > 0 && re.test(input.trim()) : null;
};

const checkAlpha = (input) => {
  const re = /^[a-zA-ZčćđšžČĆĐŠŽ\s]+$/;

  return input ? input.length > 0 && re.test(input.trim()) : null;
};

const checkAlphaNumeric = (input) => {
  const re = /^[0-9a-zA-Z\-_-]*$/;

  return input ? input.length > 0 && re.test(input.trim()) : null;
};

export { checkEmail, checkAlpha, checkAlphaNumeric };
